<template>
  <div class="not_height_datatable">
    <ag-grid-vue style="width: 100%; height: 100%"
                 class="ag-theme-balham"
                 :gridOptions="gridOptions"
                 :columnDefs="columnDefs"

                 :defaultColDef="defaultColDef"
                 :rowData="rowData"
                 :rowHeight="rowHeight"
                 :animateRows="true"
                 @first-data-rendered="onFirstDataRendered"
                 :frameworkComponents="frameworkComponents"
                 :loadingOverlayComponent="loadingOverlayComponent"
                 :loadingOverlayComponentParams="loadingOverlayComponentParams"
                 :noRowsOverlayComponent="noRowsOverlayComponent"
                 :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import Vue from 'vue';

import {AgGridVue} from "ag-grid-vue";
import OverlayLoading from "./overlay_loading";
import OverlayNoRows from "./overlay_no_rows";
import _ from 'underscore-contrib';
import lodash from 'lodash';

Vue.use(_);
Vue.use(lodash);

import {mapActions} from 'vuex'

export default {
  name: "export_datatable",
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows
  },
  props: {
    rowData: null,
    loadingMessage: {type: String, default: 'Loading...'},
    noRowsMessage: {type: String, default: 'No Rows Found'},
    columns: null,
    type: {type: String, required: true},
    recordType: {type: String, required: false},
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowHeight: null,

      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      noRowsOverlayComponent: null,
      noRowsOverlayComponentParams: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      pagination: true,
      paginationPageSize: 30,
      rowStyle: {
        'border-bottom': 'white 1px solid',
        'border-top': 'white 1px solid',
      },
      gridAutoHeight: true,
      onColumnResized: this.onColumnResized,
    };
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      filterParams: {newRowsAction: 'keep', buttons: ['reset'],},
      cellStyle: {"white-space": "normal"},
      unSortIcon: true,
      suppressMenu: true,
      autoHeight: true,
      suppressSizeToFit: false,
      flex: 1,
      wrapText: true,     // <-- HERE
    };

    this.frameworkComponents = {
      customLoadingCellRenderer: OverlayLoading,
      customNoRowsOverlay: OverlayNoRows,
    };
    this.loadingOverlayComponent = 'customLoadingCellRenderer';
    this.loadingOverlayComponentParams = {loadingMessage: this.loadingMessage};
    this.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.noRowsOverlayComponentParams = {noRowsMessage: this.noRowsMessage};

    this.columnDefs = this.columns;

    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'sp_export' && $event.type === 'delete') {
        this.rowData.splice(this.$store.state.workers.current_row_id.row_id, 1);
      }
      if ($event.table === 'sp_export' && $event.type === 'update') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.workers.current_row_id.row_id]})
      }
      if ($event.table === 'sa_export' && $event.type === 'delete') {
        this.rowData.splice(this.$store.state.workers.current_row_id.row_id, 1);
      }
      if ($event.table === 'sa_export' && $event.type === 'update') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.workers.current_row_id.row_id]})
      }
      if ($event.table === 'st_export' && $event.type === 'delete') {
        this.rowData.splice(this.$store.state.workers.current_row_id.row_id, 1);
      }
      if ($event.table === 'st_export' && $event.type === 'update') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.workers.current_row_id.row_id]})
      }
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      params.api.resetRowHeights();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    }
  },
}
</script>
